import { TableCell } from "@mui/material";
import { PropsWithChildren } from "react";

const SINGLES_ROW_HEIGHT = 40;
interface LegCellProps extends PropsWithChildren {
  sx?: any;
  hasBorderRight?: boolean;
  hasBorderLeft?: boolean;
}

export const PlayerCell: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <TableCell
      sx={{
        flex: 1,
        display: "flex",
        flexWrap: "wrap",
        p: 0,
        // verticalAlign: "middle",
        alignItems: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        justifyContent: "center",
        minHeight: SINGLES_ROW_HEIGHT,
      }}
    >
      {children}
    </TableCell>
  );
};

export const LegCell: React.FC<LegCellProps> = ({
  children,
  hasBorderRight,
  hasBorderLeft,
  sx,
}: LegCellProps) => {
  return (
    <TableCell
      sx={{
        height: SINGLES_ROW_HEIGHT,
        padding: 0,
        margin: 0,
        verticalAlign: "middle",
        position: "relative",
        borderRight: hasBorderRight ? "2px solid #000" : "",
        borderLeft: hasBorderLeft ? "2px solid #000" : "",
        textAlign: "center",
        ...sx,
      }}
    >
      {children}
    </TableCell>
  );
};

export const HighlightCell: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <TableCell
      sx={{
        flex: 1,
        border: "2px solid orange",
        display: "flex",
        flexWrap: "wrap",
        p: 0,
        // verticalAlign: "middle",
        alignItems: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        justifyContent: "center",
        minHeight: SINGLES_ROW_HEIGHT,
      }}
    >
      {children}
    </TableCell>
  );
};
